import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import { StyledButton } from 'components/SharedStyledElements';
import BaseModal, { ModalActions } from 'components/Modals/BaseModal';
import AssetMorpherWizard, { Step } from 'pages/MerchantPages/Assets/InitialCreate/StepWizard';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';
import { AssetType, Steps } from 'pages/MerchantPages/Assets/assetTypes';
import { ItemDetails } from 'ducks/merchantDucks/items/types';

// actions
import { openModal } from 'ducks/merchantDucks/modal/actions';
import { changeItemContentType, CreateItem } from 'ducks/merchantDucks/items/actions';

// hooks
import useNumericInput from 'hooks/useNumericInput';

const { Container, Cell } = Grid;

const ButtonWrapper = styled(Container)`
  margin-top: 1.5rem;
`;

interface Props {
  item: ItemDetails;
}

const ContentTypeMorpher = ({ item }: Props) => {
  const dispatch = useDispatch();

  const {
    value: currentStep,
    valueBind: { onChange: setCurrentStep },
    resetValue: resetSteps,
  } = useNumericInput(0);

  const showModal = () => {
    dispatch(openModal(ModalNames.ChangeAssetContentType));
  };

  const filterSteps = ({ id: stepId }: Step) =>
    [Steps.BasicAssetInfo, Steps.OvpVideos, Steps.OvpVideoQuickAdd, Steps.SyncJwPlayer].includes(stepId);

  const onSubmit = ({ itemType }: CreateItem) => {
    const rawContent = itemType === AssetType.Html ? ' ' : '{}';
    dispatch(
      changeItemContentType({
        itemId: item.id,
        itemType,
        rawContent,
      })
    );
  };

  return (
    <>
      <ButtonWrapper columns="1fr auto 1fr">
        <Cell left={2} center>
          <StyledButton tag="button_change_content_type" onClick={showModal}>
            Change content type
          </StyledButton>
        </Cell>
      </ButtonWrapper>
      <BaseModal
        tag="change_asset_content_type_modal"
        onOpen={resetSteps}
        title="Change asset content type"
        modalName={ModalNames.ChangeAssetContentType}
        render={({ closeModal }: ModalActions) => (
          <AssetMorpherWizard
            activeStep={currentStep}
            onStepChange={setCurrentStep}
            onSubmit={onSubmit}
            closeModal={closeModal}
            filterSteps={filterSteps}
            item={item}
          />
        )}
      />
    </>
  );
};

export default ContentTypeMorpher;
